<template>
	<div id="wrapper">
		<SidebarView :fixedAssets="true" :fixedAssetsVisible="true" :assetMovementHistoryReport="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<div class="card card-shape home-box mb-3">
						<div class="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
							<h6 class="m-0 fw-bold text-green">Asset Movement History</h6>
							<b-button class="akkurate-green-btn btn-size text-white" :disabled="exporting || !assetId" @click="exportExcel">
								<b-spinner v-if="exporting" small class="me-1" />
								Export Excel
							</b-button>
						</div>
						<div class="card-body">
							<div class="row g-2 mb-3 align-items-end">
								<div class="col-md-6">
									<label class="akkurate-dark small">Asset</label>
									<multiselect
										v-model="selectedAsset"
										:options="assetOptions"
										:internal-search="false"
										@search-change="searchAssets"
										label="asset_name"
										track-by="id"
										placeholder="Search by name/tag..."
										class="field-container"
										:custom-label="assetLabel"
									/>
								</div>
								<div class="col-md-3">
									<label class="akkurate-dark small">Or Asset ID</label>
									<b-form-input v-model="assetIdInput" type="number" min="1" class="field-container" placeholder="Enter asset id" />
								</div>
								<div class="col-md-auto d-flex gap-2">
									<b-button class="akkurate-green-btn btn-size text-white" @click="load">
										<font-awesome-icon class="me-1" :icon="['fas', 'search']" />
										Load
									</b-button>
								</div>
							</div>

							<div v-if="error" class="alert alert-danger py-2 small mb-2">{{ error }}</div>

							<b-table
								striped
								bordered
								responsive
								:busy="busy"
								:items="rows"
								:fields="fields"
								show-empty
								class="table_text_size"
							/>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>
		<ChatBot />
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";

export default {
	name: "AssetMovementHistoryReport",
	components: { SidebarView, TopbarView, ChatBot, Multiselect },
	data() {
		return {
			busy: false,
			exporting: false,
			error: "",
			rows: [],
			fields: [
				{ key: "id", label: "#" },
				{ key: "type", label: "Type" },
				{ key: "from_branch", label: "From" },
				{ key: "to_branch", label: "To" },
				{ key: "to_user", label: "To user" },
				{ key: "reason", label: "Reason" },
				{ key: "created_at", label: "Created" },
			],
			selectedAsset: null,
			assetIdInput: "",
			assetOptions: [],
		};
	},
	computed: {
		assetId() {
			return this.selectedAsset?.id || (this.assetIdInput ? Number(this.assetIdInput) : null);
		},
	},
	methods: {
		assetLabel(a) {
			if (!a) return "";
			return `${a.asset_tag ? a.asset_tag + " — " : ""}${a.asset_name || ""} (#${a.id})`;
		},
		async searchAssets(q) {
			try {
				const res = await ApiService.query("/assets", { params: { per_page: 30, q: q || "" } });
				const body = res.data;
				this.assetOptions = body.data || body || [];
			} catch (e) {
				this.assetOptions = [];
			}
		},
		async load() {
			this.error = "";
			if (!this.assetId) {
				this.error = "Please select an asset or enter asset id.";
				return;
			}
			this.busy = true;
			this.$Progress.start();
			try {
				const res = await ApiService.query("/reports/assets/movements", {
					params: { asset_id: this.assetId, per_page: 30 },
				});
				const body = res.data;
				this.rows = body.data || body || [];
			} catch (e) {
				this.rows = [];
				this.error = e.response?.data?.message || "Could not load movements.";
			} finally {
				this.busy = false;
				this.$Progress.finish();
			}
		},
		async exportExcel() {
			this.exporting = true;
			this.error = "";
			try {
				const res = await ApiService.query("/reports/assets/movements/export-excel", {
					params: { asset_id: this.assetId },
				});
				const url = res.data?.download_url;
				if (url) {
					window.open(url, "_blank", "noopener,noreferrer");
					toast.fire({ icon: "success", title: res.data?.message || "Export ready" });
				} else {
					this.error = "Export did not return a download URL.";
				}
			} catch (e) {
				if (e.response?.status === 422 && e.response?.data?.message) {
					this.error = e.response.data.message;
				} else if (e.response?.status === 422 && e.response?.data?.errors) {
					this.error = Object.values(e.response.data.errors).flat().join(" ");
				} else {
					this.error = e.response?.data?.message || "Export failed.";
				}
			} finally {
				this.exporting = false;
			}
		},
	},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

